/* @flow */

import * as React from 'react';

import featureRouter from 'src/shared/app/feature/featureRouter';
import { createFeatureDecisions } from 'src/shared/app/feature/factory/featureFactory';
import { getDisplayName } from '@braindate/util/lib/react/hoc/hocUtil';

type Props = {};

export default function withFeatureDecisions(WrappedComponent: any): any {
  const WithFeatureDecisionsComponent = (props: Props): React.Node => (
    <WrappedComponent
      {...props}
      featureDecisions={createFeatureDecisions(featureRouter)}
    />
  );

  WithFeatureDecisionsComponent.displayName = `WithFeatureDecisionsComponent(${getDisplayName(
    WrappedComponent,
  )})`;

  return WithFeatureDecisionsComponent;
}
